import { render } from "./Instruction.vue?vue&type=template&id=c01f5c66&scoped=true&ts=true"
import script from "./Instruction.vue?vue&type=script&lang=ts"
export * from "./Instruction.vue?vue&type=script&lang=ts"

import "./Instruction.vue?vue&type=style&index=0&id=c01f5c66&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c01f5c66"]])

export default __exports__